/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { modelKeysListKeys } from "../funcs/modelKeysListKeys.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListKeysResponseBody } from "../models/components/listkeysresponsebody.js";
import {
  ListModelProviderKeysRequest,
  ListModelProviderKeysSecurity,
} from "../models/operations/listmodelproviderkeys.js";
import { unwrapAsync } from "../types/fp.js";
export type ModelProviderKeysQueryData = ListKeysResponseBody;

export function prefetchModelProviderKeys(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListModelProviderKeysRequest | undefined,
  security?: ListModelProviderKeysSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildModelProviderKeysQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildModelProviderKeysQuery(
  client$: GramCore,
  request?: ListModelProviderKeysRequest | undefined,
  security?: ListModelProviderKeysSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ModelProviderKeysQueryData>;
} {
  return {
    queryKey: queryKeyModelProviderKeys({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function modelProviderKeysQueryFn(
      ctx,
    ): Promise<ModelProviderKeysQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(modelKeysListKeys(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyModelProviderKeys(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "modelKeys", "listKeys", parameters];
}
